import { array, string, func, bool } from 'prop-types'
import { WithMenu } from '../../hocs'
import Input from '../Input'
import MultiSelect from '../MultiSelect'

const selectedComparator = (option, values) => {
  if (option.id) {
    return Boolean(values.find((value) => value.id === option.id))
  }

  return Boolean(values.find((value) => value.title === option))
}

class TagInput extends Input {
  static propTypes = {
    ...Input.propTypes,
    onRemove: func,
    onSelect: func,
    onSuggest: func,
    options: array,
    term: string,
    theme: string,
    title: string,
    value: array,
    withMenu: bool,
  }

  constructor(props) {
    super(props)

    this.state = {
      focused: false,
    }

    this.onFocus = this.onFocus.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  onFocus() {
    this.setState({ focused: true })
  }

  onBlur() {
    this.setState({ focused: false })
    if (this.props.term !== '') {
      this.props.onSelect(this.props.term)
    }
  }

  render() {
    const {
      onSuggest,
      onSelect,
      onRemove,
      options,
      value,
      term,
      theme,
      title,
      withMenu,
    } = this.props
    return (
      <MultiSelect
        className="tag-input"
        selectedComparator={selectedComparator}
        focused={this.state.focused}
        onInputBlur={this.onBlur}
        onFocus={this.onFocus}
        onRemove={onRemove}
        onSelect={onSelect}
        onSuggest={onSuggest}
        options={options}
        placeholder="Add new tag..."
        shouldValidate={false}
        term={term}
        theme={theme}
        title={title}
        value={value}
        withMenu={withMenu}
      />
    )
  }
}

export default WithMenu(TagInput, {})
